/**
 * Dice primitives. The ONLY source of randomness in the rules engine.
 * Every rules function takes a Roller so tests can be fully deterministic.
 */
export interface Roller {
  /** Returns an integer from 1..sides inclusive. */
  roll(sides: number): number;
}

export const randomRoller: Roller = {
  roll(sides: number): number {
    if (!Number.isInteger(sides) || sides < 1) {
      throw new Error(`Invalid die size: ${sides}`);
    }
    return Math.floor(Math.random() * sides) + 1;
  },
};

/** A roller that returns a fixed sequence. Test and replay use only. */
export function sequenceRoller(values: readonly number[]): Roller {
  let i = 0;
  return {
    roll(): number {
      const v = values[i];
      if (v === undefined) throw new Error('sequenceRoller ran out of values');
      i += 1;
      return v;
    },
  };
}

/**
 * Rolls 1d6 rerolling any result of 1.
 * RULE DCC-CREATE-STATS-002 - Crawlers & Customization p.14
 */
export function rollD6RerollingOnes(roller: Roller, maxAttempts = 100): number {
  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    const value = roller.roll(6);
    if (value !== 1) return value;
  }
  throw new Error('rollD6RerollingOnes: too many consecutive 1s');
}
